(function () {
    if (document.body.classList.contains('template-product')) {
        
        const player0 = MusePlayer({
            container: '.muse-video-player-1',
            video: window.socialVideos[0],
            search: false,
            links: false,
            logo: false,
            title: false,
            autoplay: true,
            loop: true,
            volume: 0,
            style: "no-controls",
            width: '100%'
        });
        const player1 = MusePlayer({
            container: '.muse-video-player-2',
            video: window.socialVideos[1],
            search: false,
            links: false,
            logo: false,
            title: false,
            autoplay: true,
            loop: true,
            volume: 0,
            style: "no-controls",
            width: '100%'
        });
        const player2 = MusePlayer({
            container: '.muse-video-player-3',
            video: window.socialVideos[2],
            search: false,
            links: false,
            logo: false,
            title: false,
            autoplay: true,
            loop: true,
            volume: 0,
            style: "no-controls",
            width: '100%'
        });
        const player3 = MusePlayer({
            container: '.muse-video-player-4',
            video: window.socialVideos[3],
            search: false,
            links: false,
            logo: false,
            title: false,
            autoplay: true,
            loop: true,
            volume: 0,
            style: "no-controls",
            width: '100%'
        });
        const player4 = MusePlayer({
            container: '.muse-video-player-5',
            video: window.socialVideos[4],
            search: false,
            links: false,
            logo: false,
            title: false,
            autoplay: true,
            loop: true,
            volume: 0,
            style: "no-controls",
            width: '100%'
        });

        const players = [player0, player1, player2, player3, player4]

        const sliderSocial = new Swiper('.slider_social__slider', {
            autoplay: {
              delay: 5000,
            },
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: function (swiper) {
                    
                    players.forEach(player => {
                        
                        player.seek(0)
                    });
                    // console.log(players[swiper.activeIndex].play())
                    players[swiper.activeIndex].play()
                },
            },
        });

        
    }
})();
